import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/exception/404.vue'),
    meta: {
      name: '404'
    }
  },
  // {
  //   path: '/dashboard/message/send',
  //   name: 'send',
  //   component: () => import('@/pages/index/views/dashboard/message/send/index.vue'),
  //   meta: {
  //     name: 'send'
  //   }
  // },
  // {
  //   path: '/dashboard/message/template',
  //   name: 'template',
  //   component: () => import('@/pages/index/views/dashboard/message/template/index.vue'),
  //   meta: {
  //     name: 'template'
  //   }
  // },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
